/** Раздел словаря «admin»: администрирование площадки (обзор, пользователи, розыгрыши). */
export const admin = {
  title: 'Администрирование',
  signedIn: 'Вы вошли как администратор',
  noPlay: 'Администратор не участвует в розыгрышах.',
  'tab.overview': 'Обзор',
  'tab.users': 'Пользователи',
  'tab.games': 'Розыгрыши',

  // обзор: данные
  'data.title': 'Данные',
  'data.mode': 'Режим',
  'data.modeReplay': 'история',
  'data.modeLive': 'реальное время',
  'data.modeReplayHint': 'воспроизведение истории; результаты не входят в рейтинг основного режима',
  'data.source': 'Источник',
  'data.sourceSynthetic': 'синтетика',
  // обзор: пользователи
  'users.total': 'Всего',
  'users.online': 'В сети',
  'users.new24h': 'Новых за сутки',
  'users.new7d': 'Новых за неделю',
  'users.active7d': 'Играли за неделю',
  'users.banned': 'Заблокировано',
  'users.withPassword': 'С паролем',
  'users.withSso': 'Через сервисы',
  // обзор: розыгрыши
  'games.total': 'Всего',
  'games.last24h': 'За сутки',
  'games.completed': 'Состоялось',
  'games.cancelled': 'Отменено',
  'games.avgPlayers': 'Игроков в среднем',
  'games.humanShare': 'Доля людей',
  'games.humanShareHint': 'люди среди всех участников (остальные — боты)',
  // обзор: кредиты
  'credits.title': 'Кредиты',
  'credits.bank': 'Счёт банка',
  'credits.bankHint': 'накопленная комиссия',
  'credits.commissionTotal': 'Комиссия всего',
  'credits.granted': 'Выдано игрокам',
  'credits.grantedHint': 'стартовые и восстановленные балансы',
  'credits.inPlay': 'Сейчас в банках',
  'credits.inPlayHint': 'внесено в незавершённые розыгрыши',
  'credits.potTotal': 'Оборот банков',
  // обзор: сейчас
  'rooms.title': 'Сейчас',
  'rooms.open': 'Открыто столов',
  'rooms.playing': 'Идёт розыгрышей',
  'rooms.seated': 'Людей за столами',
  'rooms.spectators': 'Наблюдателей',
  // обзор: по дням, по столам, лучшие игроки
  'daily.games': 'Розыгрыши по дням',
  'daily.gamesValue': '{n} розыгрыш|{n} розыгрыша|{n} розыгрышей',
  'daily.commission': 'Комиссия по дням',
  'byTable.title': 'По столам',
  'byTable.empty': 'Розыгрышей пока не было.',
  'byTable.ante': 'Взнос',
  'byTable.games': 'Розыгрышей',
  'byTable.pot': 'Оборот',
  'byTable.commission': 'Комиссия',
  'top.title': 'Лучшие игроки',
  'top.empty': 'Пока никто не играл.',
  'top.games': '{n} игра|{n} игры|{n} игр',

  // вкладка «Пользователи»
  'list.banPrompt': 'Причина блокировки игрока {name} (видна игроку):',
  'list.searchPlaceholder': 'Поиск по имени, логину или id',
  'list.searchLabel': 'Поиск пользователей',
  'list.filterAll': 'Все',
  'list.filterOnline': 'В сети',
  'list.filterBanned': 'Заблокированные',
  'list.empty': 'Никого не найдено.',
  'list.colPlayer': 'Игрок',
  'list.colLogin': 'Вход',
  'list.colActivity': 'Активность',
  'list.colGames': 'Игр',
  'list.colWinRate': 'Винрейт',
  'list.colNet': 'Итог',
  'list.colBalance': 'Баланс',
  'list.tagOnline': 'в сети',
  'list.tagBanned': 'заблокирован',
  'list.sessionOnly': 'только сессия',
  'list.now': 'сейчас',
  'list.profile': 'Профиль',
  'list.ban': 'Заблокировать',
  'list.unban': 'Разблокировать',
};
